// @ts-expect-error: Flow to TS migration.
import type { Route } from "react-router-config"
import NotFound from "@kiwicom/frontend-common/components/NotFound/NotFound"

import * as Routes from "../router/RoutesSync"
import Root from "../scenes/Root"

export default function getRouter(lang: string): Route[] {
  const prefix = `/${lang}`

  return [
    {
      path: `${prefix}`,
      component: Root,
      routes: [
        {
          path: `${prefix}/manage/:bookingId`,
          component: Routes.AccountBooking,
          name: "manage",
        },
        {
          path: `${prefix}/account/bookings/:bookingId?`,
          component: Routes.AccountBooking,
          name: "account",
        },
        {
          status: 404,
          component: NotFound,
        },
      ],
    },
    {
      status: 404,
      component: NotFound,
    },
  ]
}
